import mapKnownValues from "../utils/mapKnownValues";

export type DestinationAccountResponse = {
  destinationAccountType: AccountType;
  transferId: number;
  destinationAccountId: number;
  providerName: string | null;
  planName: string | null;
  planNumber: string | null;
  planSponsor: string | null;
  traditionalIraAccountNumber: string | null;
  rothIraAccountNumber: string | null;
  destinationStatementFileNames: string[];
};

export enum DestinationType {
  traditionalDestination = "DESTINATION",
  rothDestination = "ROTH_DESTINATION",
}

export enum AccountType {
  employerSponsored = "EMPLOYER_SPONSORED",
  ira = "IRA",
  ANNUITY = "ANNUITY",
}

export type TransferDestinationPlanType = "BOTH" | "ROTH" | "TRADITIONAL";

/* IF DestinationAccountType === EMPLOYER_SPONSORED
planSponsor, planName, planType, planNumber are required

IF DestinationAccountType === IRA
traditionalIRAAccountNumber is required
*/

class DestinationAccount {
  transferId = -1;
  destinationAccountId = -1;
  destinationType: DestinationType = DestinationType.traditionalDestination;
  destinationAccountType: AccountType = AccountType.ira;
  providerName = "";
  planSponsor = "";
  planName = "";
  planNumber = "";
  custodianName = "";
  planType: TransferDestinationPlanType | null = null;
  traditionalIraAccountNumber: string | null = "";
  rothIraAccountNumber: string | null = "";
  statementSkipped: string | boolean = "TRUE";
  yetToOpen: boolean | null = false;
  destinationStatementFileNames: string[] = [];
  accountOpeningUrl: string | null = null;

  constructor(params: Partial<DestinationAccount> = {}) {
    mapKnownValues(this, params);
  }

  static fromApi(response?: DestinationAccountResponse | undefined) {
    if (!response) return new DestinationAccount();
    // We must convert null to the type we understand
    const newResponse: Partial<DestinationAccount> = {
      ...response,
      providerName: response.providerName || undefined,
      planName: response.planName || undefined,
      planNumber: response.planNumber || undefined,
      planSponsor: response.planSponsor || undefined,
      traditionalIraAccountNumber: response.traditionalIraAccountNumber || undefined,
    };
    return new DestinationAccount(newResponse);
  }
}

export default DestinationAccount;
